import { Badge, FontColorEnum, Tooltip } from '@acceso/design-system';

import { useUsersByIds } from '@/features/users/api/get-user';
import { User } from '@/features/users/types/types';

import { UserAction } from '../UserAction';

type TCurrentUsersProps = {
  ids: string[];
  limit?: number;
};

const CurrentUsers = ({ ids, limit = 1 }: TCurrentUsersProps) => {
  const currentUsers = useUsersByIds({
    ids,
  })
    .map(({ data }) => data)
    .filter(Boolean) as User[];

  if (currentUsers.length === 0) return <></>;

  const visibleUsers = currentUsers.slice(0, limit);
  const remainingUsers = currentUsers.slice(limit);

  return (
    <div className="flex select-none gap-1" data-id="current-users">
      {visibleUsers.map(user => (
        <UserAction key={user.id} id={user.id} hideTimestamp={true} isAvatar />
      ))}
      {remainingUsers.length > 0 && (
        <Tooltip
          help={
            <div className="flex w-fit max-w-2xl select-none flex-wrap items-center justify-center">
              {remainingUsers.map((user, index) => (
                <span key={user.id}>
                  {user.first_name} {user.last_name}
                  {index !== remainingUsers.length - 1 && ', '}
                </span>
              ))}
            </div>
          }
          grow
        >
          <Badge color={FontColorEnum.Default} className="select-none">
            + {remainingUsers.length}
          </Badge>
        </Tooltip>
      )}
    </div>
  );
};

export { CurrentUsers };
